/*
 * boats.js
 * Decorative marine vessel SVG illustrations for a commercial fishing equipment site.
 * Plain browser JS. Defines a single global: window.ProductBoatSVG with four methods,
 * each returning a complete <svg> markup STRING. All boats face RIGHT (bow on the right),
 * side profile, sitting on an implied waterline near the bottom of the viewBox.
 */
(function () {
  'use strict';

  var ProductBoatSVG = {
    /*
     * Center-console sport cruiser / parasailing vessel.
     * 280 wide. White fiberglass hull, blue waterline accent, darker lower hull,
     * T-top frame, parasail winch drum on transom, windshield, twin outboards.
     */
    parasailBoat: function () {
      var W = 280;
      var H = 134;
      return '' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" preserveAspectRatio="xMidYMid meet">' +
          // waterline reference stripe (sea)
          '<rect x="0" y="120" width="280" height="14" fill="#bcdcea"/>' +
          // twin outboard motors at the transom (left = stern, boat faces right)
          '<rect x="12" y="92" width="14" height="30" rx="2" fill="#3a4654"/>' +
          '<rect x="22" y="96" width="12" height="26" rx="2" fill="#4a586a"/>' +
          '<rect x="15" y="96" width="6" height="10" fill="#2b333d"/>' +
          // parasail winch drum on rear transom (horizontal cylinder + end-cap ellipse)
          '<rect x="34" y="70" width="40" height="20" rx="3" fill="#c9ced4"/>' +
          '<rect x="34" y="70" width="40" height="6" rx="3" fill="#e2e6ea"/>' +
          '<ellipse cx="34" cy="80" rx="6" ry="10" fill="#9aa1aa"/>' +
          '<ellipse cx="34" cy="80" rx="3" ry="5" fill="#6f767f"/>' +
          '<ellipse cx="74" cy="80" rx="5" ry="10" fill="#aeb4bc"/>' +
          // post supports for the drum frame
          '<rect x="36" y="86" width="3" height="22" fill="#7f868f"/>' +
          '<rect x="70" y="86" width="3" height="22" fill="#7f868f"/>' +
          // lower hull (below waterline) - darker for depth
          '<path d="M18 108 L262 108 L246 122 L40 122 Z" fill="#d9dde2"/>' +
          // blue waterline accent stripe
          '<path d="M18 104 L264 104 L262 110 L18 110 Z" fill="#1f6fb2"/>' +
          // hull topsides (side) - white fiberglass, slightly off-white
          '<path d="M20 78 L200 78 L266 104 L18 104 Z" fill="#eef1f4"/>' +
          // sheer / deck top edge - lighter highlight
          '<path d="M20 78 L200 78 L210 84 L24 84 Z" fill="#ffffff"/>' +
          // thin rub rail seam along the hull
          '<line x1="20" y1="90" x2="262" y2="100" stroke="#c4cad1" stroke-width="1.5"/>' +
          // bow sweep highlight to the right
          '<path d="M198 78 L266 104 L268 100 L210 76 Z" fill="#dfe4e9"/>' +
          // center console base
          '<rect x="118" y="58" width="40" height="22" rx="3" fill="#e6e9ed"/>' +
          '<rect x="118" y="58" width="40" height="6" rx="3" fill="#f6f8f9"/>' +
          // windshield on console (tinted glass)
          '<path d="M150 58 L168 58 L168 46 L150 52 Z" fill="#9fcbe0" stroke="#7fb0cb" stroke-width="1"/>' +
          // T-top frame: two vertical posts + horizontal roof
          '<rect x="120" y="20" width="4" height="40" fill="#5a626b"/>' +
          '<rect x="152" y="20" width="4" height="40" fill="#5a626b"/>' +
          '<rect x="108" y="18" width="62" height="6" rx="3" fill="#6b737c"/>' +
          '<rect x="108" y="18" width="62" height="2" rx="1" fill="#868d95"/>' +
          // small antenna on the T-top
          '<line x1="166" y1="18" x2="172" y2="2" stroke="#3a4048" stroke-width="1.5"/>' +
        '</svg>';
    },

    /*
     * Parasail canopy with six alternating color panels (red/white/blue/yellow/red/white),
     * four converging lines down to a point near bottom-center, and a person silhouette.
     * 120 wide, taller viewBox (~width*1.4) for the dropping lines.
     */
    parasailCanopy: function () {
      var W = 120;
      var H = 168;
      return '' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" preserveAspectRatio="xMidYMid meet">' +
          // canopy: wide curved arch near the top, narrowing toward the base.
          // six panels clipped against the overall canopy shape by drawing each panel path.
          // overall canopy outline (for the rounded top edge): from (8,40) arc to (112,40)
          // Panel 1 (red)
          '<path d="M8 42 Q10 14 26 12 L34 12 L30 50 L14 50 Z" fill="#cc2b2b"/>' +
          // Panel 2 (white)
          '<path d="M26 12 L44 11 L42 50 L30 50 Z" fill="#f2f3f5"/>' +
          // Panel 3 (blue)
          '<path d="M44 11 L60 11 L58 50 L42 50 Z" fill="#1f6fb2"/>' +
          // Panel 4 (yellow)
          '<path d="M60 11 L76 11 L78 50 L58 50 Z" fill="#f2c233"/>' +
          // Panel 5 (red)
          '<path d="M76 11 L94 12 L90 50 L78 50 Z" fill="#cc2b2b"/>' +
          // Panel 6 (white)
          '<path d="M94 12 L112 42 L106 50 L90 50 Z" fill="#f2f3f5"/>' +
          // canopy bottom shadow edge
          '<path d="M14 50 L106 50 L102 54 L18 54 Z" fill="#0000001a"/>' +
          // four thin converging lines from canopy base to a point near bottom-center (60,150)
          '<line x1="22" y1="52" x2="60" y2="150" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>' +
          '<line x1="44" y1="53" x2="60" y2="150" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>' +
          '<line x1="76" y1="53" x2="60" y2="150" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>' +
          '<line x1="98" y1="52" x2="60" y2="150" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>' +
          // person silhouette in a harness, ~15px tall, seated human shape, dark fill
          '<g fill="#23282e">' +
            // head
            '<circle cx="60" cy="138" r="3"/>' +
            // torso
            '<rect x="57" y="141" width="6" height="8" rx="2"/>' +
            // seated legs (bent forward)
            '<path d="M60 149 L70 151 L70 153 L60 152 Z"/>' +
            // lower legs
            '<path d="M70 151 L72 158 L70 158 L67 152 Z"/>' +
            // arms reaching up to lines
            '<path d="M58 142 L52 137 L53 136 L59 141 Z"/>' +
          '</g>' +
        '</svg>';
    },

    /*
     * Large commercial fishing trawler ("Bottom Reels").
     * 320 wide. Dark navy hull, red anti-fouling lower hull, forward white wheelhouse,
     * tall radar mast, outrigger poles folded back along the hull, large open aft deck.
     */
    trawlerBoat: function () {
      var W = 320;
      var H = 154;
      return '' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" preserveAspectRatio="xMidYMid meet">' +
          // sea / waterline reference
          '<rect x="0" y="132" width="320" height="22" fill="#aecfde"/>' +
          // anti-fouling RED lower hull (below waterline)
          '<path d="M14 116 L306 116 L286 134 L34 134 Z" fill="#a23128"/>' +
          // darker red shadow at very bottom
          '<path d="M30 130 L290 130 L286 134 L34 134 Z" fill="#7f261f"/>' +
          // navy waterline boot stripe
          '<path d="M14 112 L308 112 L306 118 L14 118 Z" fill="#101a2c"/>' +
          // dark navy hull side (long, low) - bow sweeping up on the right
          '<path d="M16 80 L250 80 Q300 82 312 112 L14 112 Z" fill="#1f3050"/>' +
          // slightly lighter navy upper hull band for depth
          '<path d="M16 80 L250 80 Q300 82 308 96 L16 96 Z" fill="#2a3e63"/>' +
          // rub rail (thin darker line) along the upper hull
          '<line x1="18" y1="84" x2="305" y2="92" stroke="#0d1626" stroke-width="2"/>' +
          // hull plate seam lines (thin darker)
          '<line x1="40" y1="100" x2="300" y2="104" stroke="#16243c" stroke-width="1"/>' +
          '<line x1="60" y1="108" x2="295" y2="110" stroke="#16243c" stroke-width="1"/>' +
          // bulwark top edge highlight
          '<path d="M16 80 L250 80 Q300 82 312 112 L308 112 Q298 84 250 83 L16 83 Z" fill="#33486f"/>' +
          // large open deck space (aft of wheelhouse) - deck surface
          '<rect x="40" y="72" width="120" height="10" fill="#3c4a5e"/>' +
          // white superstructure / wheelhouse positioned FORWARD (right of center)
          '<rect x="168" y="44" width="78" height="38" rx="2" fill="#f1f3f5"/>' +
          // wheelhouse shadow side
          '<rect x="168" y="44" width="78" height="8" fill="#ffffff"/>' +
          '<rect x="236" y="44" width="10" height="38" fill="#dfe3e7"/>' +
          // wheelhouse upper bridge
          '<rect x="186" y="26" width="48" height="20" rx="2" fill="#e7eaed"/>' +
          // bridge windows (wraparound)
          '<rect x="190" y="30" width="40" height="9" rx="1" fill="#5b7f97"/>' +
          '<line x1="203" y1="30" x2="203" y2="39" stroke="#3f5d70" stroke-width="1"/>' +
          '<line x1="216" y1="30" x2="216" y2="39" stroke="#3f5d70" stroke-width="1"/>' +
          // lower wheelhouse windows / doors
          '<rect x="174" y="54" width="14" height="16" rx="1" fill="#5b7f97"/>' +
          '<rect x="194" y="54" width="14" height="16" rx="1" fill="#5b7f97"/>' +
          '<rect x="214" y="54" width="10" height="20" rx="1" fill="#cfd5da"/>' +
          // tall radar mast with thin antenna
          '<rect x="208" y="6" width="4" height="22" fill="#39424f"/>' +
          '<line x1="210" y1="6" x2="210" y2="-2" stroke="#39424f" stroke-width="1.5"/>' +
          '<rect x="200" y="10" width="20" height="4" rx="2" fill="#525c69"/>' +
          // radar scanner bar on mast
          '<line x1="196" y1="18" x2="224" y2="18" stroke="#39424f" stroke-width="2"/>' +
          // outrigger poles folded back ALONG the hull (near-horizontal, lying along deck)
          '<line x1="44" y1="70" x2="200" y2="40" stroke="#2c333c" stroke-width="2.5"/>' +
          '<line x1="44" y1="74" x2="196" y2="48" stroke="#2c333c" stroke-width="2.5"/>' +
          // a-frame / gallows post at the mast base supporting the outriggers
          '<rect x="196" y="36" width="4" height="40" fill="#2c333c"/>' +
        '</svg>';
    },

    /*
     * Chesapeake Bay deadrise crab/work boat ("Trap Haulers").
     * 260 wide. Pale blue hull with white trim, deadrise V-bottom at the stern,
     * boxy forward wheelhouse with two windows, upright hydraulic hauler arm, open aft deck.
     */
    crabBoat: function () {
      var W = 260;
      var H = 124;
      return '' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" preserveAspectRatio="xMidYMid meet">' +
          // sea / waterline reference
          '<rect x="0" y="106" width="260" height="18" fill="#b6d6e6"/>' +
          // deadrise V-bottom at the stern (left side) + lower hull below waterline
          '<path d="M12 92 L248 92 L232 106 L40 106 Z" fill="#e9f0f4"/>' +
          // characteristic deadrise V at the stern
          '<path d="M12 92 L40 106 L20 100 Z" fill="#dbe4ea"/>' +
          // waterline trim stripe (white)
          '<path d="M12 88 L250 88 L248 94 L12 94 Z" fill="#ffffff"/>' +
          // pale blue hull side (wide, flat, low freeboard) - bow up on the right
          '<path d="M14 66 L210 66 Q244 68 250 90 L12 90 Z" fill="#9cc4dd"/>' +
          // darker blue lower band for depth
          '<path d="M14 78 L250 80 L250 90 L12 90 Z" fill="#7fb0cf"/>' +
          // white trim / sheer stripe along the top edge
          '<path d="M14 66 L210 66 Q244 68 250 76 L14 76 Z" fill="#f4f8fb"/>' +
          // thin rub rail seam
          '<line x1="16" y1="72" x2="248" y2="80" stroke="#6699bb" stroke-width="1.5"/>' +
          // open work deck (aft, low) - deck rail line
          '<rect x="30" y="60" width="110" height="8" fill="#cdd8de"/>' +
          '<line x1="30" y1="60" x2="140" y2="60" stroke="#aab8c0" stroke-width="1.5"/>' +
          // small forward, boxy wheelhouse with two visible windows
          '<rect x="150" y="34" width="60" height="34" rx="1" fill="#f1f4f6"/>' +
          '<rect x="150" y="34" width="60" height="7" fill="#ffffff"/>' +
          '<rect x="202" y="34" width="8" height="34" fill="#dde3e7"/>' +
          // wheelhouse roof
          '<rect x="146" y="30" width="68" height="6" rx="2" fill="#dfe5e9"/>' +
          // two windows on the wheelhouse
          '<rect x="158" y="42" width="18" height="14" rx="1" fill="#5e8298"/>' +
          '<rect x="182" y="42" width="18" height="14" rx="1" fill="#5e8298"/>' +
          '<line x1="167" y1="42" x2="167" y2="56" stroke="#436278" stroke-width="0.8"/>' +
          // small mast / exhaust on the wheelhouse
          '<rect x="168" y="18" width="3" height="14" fill="#445059"/>' +
          '<line x1="169" y1="18" x2="169" y2="8" stroke="#445059" stroke-width="1.2"/>' +
          // hydraulic hauler arm on the near side: upright arm rising from the deck rail
          '<rect x="96" y="34" width="6" height="30" fill="#3f4a54"/>' +
          // pivoting top of the hauler arm reaching out over the rail
          '<rect x="96" y="34" width="26" height="5" rx="2" fill="#4d5a66"/>' +
          // pulley / sheave at the arm tip
          '<circle cx="122" cy="37" r="4" fill="#6b757e"/>' +
          '<circle cx="122" cy="37" r="1.6" fill="#2f363d"/>' +
          // hauler base mount on the rail
          '<rect x="92" y="58" width="14" height="6" rx="1" fill="#2f373f"/>' +
          // hauling line dropping over the side
          '<line x1="122" y1="41" x2="122" y2="70" stroke="#5a636b" stroke-width="1"/>' +
        '</svg>';
    }
  };

  if (typeof window !== 'undefined') {
    window.ProductBoatSVG = ProductBoatSVG;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = ProductBoatSVG;
  }
})();
